import React from 'react';
import { Box, Heading, Text, Stack, Button, Link, Image } from '@chakra-ui/react';

const ProjectClosed = () => {
  return (
    <Box py={{ base: 10, md: 16 }}>
      <Stack spacing={8} textAlign="center" maxW="3xl" mx="auto">
        <Box>
          <Link href="https://zakhm.sa" isExternal>
            <Image
              src="/images/Zakhm.svg"
              alt="Zakhm.sa"
              height="40px"
              mx="auto"
              mb={4}
              fallbackSrc="https://majalisna-files-2025.s3.me-south-1.amazonaws.com/public-folder/zakhmlogo.svg"
            />
          </Link>
        </Box>
        <Heading as="h1" size="xl">
          تم إكمال مشروع مجالسنا
        </Heading>
        <Text fontSize="lg" color="gray.600">
          هذه النسخة من منصة مجالسنا قد أدت دورها بنجاح، ولم تعد متاحة للتقديم أو إدارة الطلبات.
        </Text>
        <Text fontSize="md" color="gray.600">
          تم تطوير هذا المشروع وتنفيذه بواسطة فريق زخم لخدمة الرحلة الانتخابية لمجالس الأحياء.
          يمكنكم التعرف على أعمالنا الأخرى والتعاون معنا من خلال موقعنا الإلكتروني.
        </Text>
        <Stack direction={{ base: 'column', sm: 'row' }} spacing={4} justify="center">
          <Button
            as={Link}
            href="https://zakhm.sa"
            isExternal
            colorScheme="brown"
            size="lg"
          >
            زيارة موقع زخم
          </Button>
        </Stack>
        <Text fontSize="sm" color="gray.500">
          في حال وجود منصات أو مشاريع جديدة مرتبطة بمجالس الأحياء، سيتم الإعلان عنها عبر القنوات الرسمية ذات العلاقة.
        </Text>
      </Stack>
    </Box>
  );
};

export default ProjectClosed;
